import { Map } from 'immutable';
import createReducer from './utils/createReducer';
import { CLEAR_SCENE } from './actionTypes';

const SET_ANNOTATION_PROPERTIES = 'SET_ANNOTATION_PROPERTIES';
const USE_CUSTOM_ANNOTATION_FUNCTION = 'USE_CUSTOM_ANNOTATION_FUNCTION';

/**
 * Annotations
 *
 * @module annotations
 * @public
 *
 */

const initialState = Map({
  customAnnotationFn: null,
});

const reducer = createReducer(initialState, {
  [SET_ANNOTATION_PROPERTIES](state, { id, attrs }) {
    let props = state.get('id') || Map();
    return state.set(id, props.merge(attrs));
  },

  [USE_CUSTOM_ANNOTATION_FUNCTION](state, annotationFn) {
    return state.set('customAnnotationFn', annotationFn);
  },

  [CLEAR_SCENE](state) {
    return Map({ customAnnotationFn: state.get('customAnnotationFn') });
  },
});

export function setAnnotationProperties(id, attrs) {
  return { type: SET_ANNOTATION_PROPERTIES, payload: { id, attrs } };
};

/**
 * Open annotation node in the player.
 * @param {String} id - id of the annotation node.
 * @public
 */
export function openAnnotation(id) {
  return { type: SET_ANNOTATION_PROPERTIES, payload: { id, attrs: { pinned: true, open: true } } };
};

/**
 * Close annotation node.
 * @param {String} id - id of the annotation node.
 * @public
 */
export function closeAnnotation(id) {
  return { type: SET_ANNOTATION_PROPERTIES, payload: { id, attrs: { pinned: false, open: false } } };
};

/**
 * Use custom annotations. Set a custom function that will be called for every
 * annotation on every scene update. The arguments passed to this function
 * will be the [annotation object](global.html#Annotation), and the div that
 * any annotations may be created under. This div has `pointer-events` set
 * to none so that the scene below it will receive all mouse/touch events.
 * If you wish to handle events in your annotations, make sure to set `pointer-events`.
 *
 * @public
 * @param {Function} fn The function to be called for every annotation update.
 */
export function useCustomAnnotationFunction(fn) {
  return { type: USE_CUSTOM_ANNOTATION_FUNCTION, payload: fn };
};

export function getCustomAnnotationFunction(store) {
  return store.getIn(['annotations', 'customAnnotationFn']);
};

const publicApi = {
  reducer,
  actions: {
    setAnnotationProperties, openAnnotation, closeAnnotation,
    useCustomAnnotationFunction,
  },
  selectors: { getCustomAnnotationFunction },
};

export default publicApi;



// WEBPACK FOOTER //
// ./src/modules/annotations.js